import { render, staticRenderFns } from "./immigrant_yukon.vue?vue&type=template&id=4d86617c&"
import script from "./immigrant_yukon.vue?vue&type=script&lang=js&"
export * from "./immigrant_yukon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports